var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchipelagosLabsScalabilityIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 70 70",
    style: {
      enableBackground: "new 0 0 70 70"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000013163906984214168030000017041811666216130441_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M61,6.6l-7.1,2.9c-0.2,0.1-0.2,0.3-0.2,0.4c0,0.1,0.1,0.1,0.2,0.2l1.7,0.7l-12.7,13L42.2,22 c-0.1-0.2-0.3-0.2-0.4-0.2c-0.1,0-0.1,0.1-0.2,0.2l-2.8,7.1c-0.1,0.2,0,0.4,0.2,0.4c0.1,0,0.2,0,0.3,0l7.1-2.9 c0.2-0.1,0.2-0.3,0.2-0.4c0-0.1-0.1-0.1-0.2-0.2l-1.7-0.7l12.7-13l0.7,1.7c0.1,0.2,0.3,0.2,0.4,0.2c0.1,0,0.1-0.1,0.2-0.2l2.8-7.1 c0-0.2-0.1-0.3-0.3-0.4C61.1,6.5,61,6.6,61,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M38.5,61.9V35.1l0,0c-0.1-1.6-1.3-3.6-5.8-5.3c-4-1.3-8.2-2-12.5-1.9c-4.2-0.1-8.4,0.6-12.5,1.9 c-4.1,1.5-5.5,3.4-5.8,4.9H1.8v27.3c0,1.7,1,3.9,5.8,5.7c4,1.3,8.2,2,12.5,1.9c4.2,0.1,8.4-0.6,12.5-1.9 C37.5,65.8,38.5,63.5,38.5,61.9z M35.8,61.8L35.8,61.8v0.2c0,0.8-1.1,2.1-4.1,3.2c-3.7,1.2-7.6,1.8-11.5,1.7 c-3.9,0.1-7.8-0.5-11.6-1.7c-3-1.1-4.1-2.4-4.1-3.2c0,0,0-0.1,0-0.1l0,0v-4.6c1,0.6,2.1,1.1,3.2,1.5c4,1.4,8.2,2,12.5,2 c4.2,0.1,8.4-0.6,12.5-2c1.1-0.4,2.2-0.9,3.2-1.5V61.8z M35.8,52.9L35.8,52.9v0.2c0,0.8-1.1,2.1-4.1,3.2 c-3.7,1.2-7.6,1.8-11.5,1.8c-3.9,0.1-7.8-0.5-11.6-1.7c-3-1.1-4.1-2.4-4.1-3.2c0,0,0-0.1,0-0.1l0,0v-4.6c1,0.6,2.1,1.2,3.2,1.6 c4,1.3,8.2,2,12.5,1.9c4.2,0.1,8.4-0.6,12.5-1.9c1.1-0.4,2.2-0.9,3.2-1.6V52.9z M35.8,44.2L35.8,44.2v0.2c0,0.8-1.1,2.1-4.1,3.2 c-3.7,1.2-7.6,1.8-11.5,1.7c-3.9,0.1-7.8-0.5-11.6-1.7c-3-1.1-4.1-2.4-4.1-3.2c0,0,0-0.1,0-0.1l0,0v-4.7c1,0.6,2.1,1.2,3.2,1.6 c4,1.3,8.2,2,12.5,1.9c4.2,0.1,8.4-0.6,12.5-1.9c1.1-0.4,2.2-0.9,3.2-1.5V44.2z M31.7,38.6c-3.7,1.2-7.6,1.8-11.5,1.7 c-3.9,0.1-7.8-0.5-11.6-1.7c-3-1.1-4.1-2.4-4.1-3.2c0-0.8,1.1-2,4.1-3.2c3.7-1.2,7.6-1.8,11.6-1.7c3.9-0.1,7.8,0.5,11.5,1.7 c3,1.1,4.1,2.4,4.1,3.2S34.7,37.5,31.7,38.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.8,44.1c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h0C33.4,43.3,33.8,43.6,33.8,44.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,45c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h0C30.6,44.2,31,44.6,31,45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.2,45.6c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h0 C27.8,44.8,28.2,45.2,28.2,45.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.8,52.8c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h0C33.4,52,33.8,52.4,33.8,52.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31,53.8c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h0C30.6,53,31,53.3,31,53.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.2,54.3c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h0 C27.8,53.5,28.2,53.9,28.2,54.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,61.5c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8l0,0C33.6,60.7,34,61.1,34,61.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.2,62.5c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h0C30.9,61.7,31.2,62,31.2,62.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M28.4,63.1c0,0.4-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8c0-0.4,0.4-0.8,0.8-0.8h0C28.1,62.3,28.4,62.6,28.4,63.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.3,0.5h8.5v2.8h-8.5V0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.9,12.9h2.8v8.5H1.9V12.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,68.6h4.9v-2.8h-0.6C37,67,35.6,67.9,34,68.6L34,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.6,65.8h8.5v2.8h-8.5V65.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.7,29.6v-5.4H1.9v7.5C2.7,30.8,3.7,30.1,4.7,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,0.5h8.5v2.8H20L20,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.5,0.5H51v2.8h-8.5V0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.7,0.5h8.5v2.8H8.7L8.7,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M4.7,7.3c0-1.4,0.8-2.7,2-3.4L5.3,1.4C3.2,2.6,1.9,4.9,1.9,7.3v2.9h2.8V7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,13.8h2.8v8.5h-2.8V13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,36.4h2.8v8.5h-2.8V36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52.9,65.8v2.8h8.5v-2.8H52.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.7,2.1l-1.8,2.1c0.9,0.8,1.4,1.9,1.5,3.1V11h2.8V7.3C68.2,5.3,67.3,3.3,65.7,2.1L65.7,2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,25.1h2.8v8.5h-2.8V25.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M53.8,0.5v2.8h7.6c0.2,0,0.4,0,0.7,0l0.5-2.7c-0.4-0.1-0.7-0.1-1.1-0.1H53.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,47.7h2.8v8.5h-2.8V47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.4,61.8c0,1.4-0.8,2.7-2,3.4l1.4,2.4c2.1-1.2,3.3-3.4,3.3-5.8v-2.9h-2.8V61.8z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchipelagosLabsScalabilityIcon);
export default __webpack_public_path__ + "static/media/Archipelagos_Labs-ScalabilityIcon.f0b4f9f0069011a58498cf31ad58d089.svg";
export { ForwardRef as ReactComponent };